import { Component } from '@angular/core';
import { ConfigService } from '../../../services/config.service';
import { ApiService } from '../../../services/api.service';
import { AuthService } from '../../../services/auth.service';

@Component({
  template: '',
  styleUrls: ['user-actions-book-clubs.component.scss'],
})
export class UserActionsBookClubsComponent {
  bookSection = 'section=';

  constructor(
    public configService: ConfigService,
    public authService: AuthService,
    public apiService: ApiService
  ) {}

  goToBookClub(section: string) {
    const wnd = window.open();
    const userId = this.authService.isAuthenticated() ? this.authService.getLoggedUser().id : null;

    const params = {
      section: section,
      patronId: userId,
    };

    this.apiService.getLinkToBookclub(params).subscribe((url) => {
      if (!url.includes('section')) {
        url = url + '&section=' + params['section'];
      }
      wnd.location.href = url;
    });
  }
}
